/* ============================================================================
   NOLESSIA · nls-elite.js — el movimiento. Vanilla, sin dependencias.

   POR QUE EXISTE: se midio el theme el 19-sep-2026 y tenia CERO reveals, CERO
   micro-interacciones en 9 secciones y un solo @keyframes. El movimiento
   sale de aqui, no de mas secciones.

   REGLA DE ORO: **nace visible**. Este script pone `js-mov` en <html> y SOLO
   entonces el CSS oculta lo que va a animar. Si el JS no carga, la pagina se ve
   entera. Nunca una pagina en blanco por una animacion.

   Todo respeta `prefers-reduced-motion`.
   ========================================================================== */
(function () {
  "use strict";

  var quieto = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!quieto) document.documentElement.classList.add("js-mov");

  function alCargar(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  alCargar(function () {

    /* ---- 1 · PARTIR TITULARES EN PALABRAS ---------------------------------
       Solo texto plano: si el titular lleva HTML dentro no se toca, para no
       romper enlaces ni <em>. */
    document.querySelectorAll("[data-partir]").forEach(function (el) {
      if (el.children.length) return;
      var t = el.textContent.trim();
      if (!t) return;
      el.innerHTML = t.split(/\s+/).map(function (w, i) {
        return '<span class="palabra" style="--i:' + i + '">' + w + "</span>";
      }).join(" ");
    });

    /* ---- 2 · REVELAR AL ENTRAR EN PANTALLA -------------------------------- */
    if ("IntersectionObserver" in window && !quieto) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("visible"); io.unobserve(e.target); }
        });
      }, { threshold: 0.22, rootMargin: "0px 0px -6% 0px" });
      document.querySelectorAll("[data-revelar]").forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll("[data-revelar]").forEach(function (el) { el.classList.add("visible"); });
    }

    /* ---- 3 · CABECERA que se esconde al bajar y vuelve al subir ------------ */
    var cab = document.querySelector(".cabecera");
    if (cab) {
      var anterior = 0;
      addEventListener("scroll", function () {
        var y = window.scrollY;
        cab.classList.toggle("esta-pegada", y > 40);
        cab.classList.toggle("se-esconde", y > anterior && y > 280);
        anterior = y;
      }, { passive: true });
    }

    /* 26-sep · fuera 4 (botón magnético), 5 (rastro de huellas: creaba un SVG cada 100 ms al mover el ratón) y 6 (vídeo por scroll, sin uso): el estilo actual los ocultaba pero seguían ejecutándose. */

    /* ---- 7 · PACKS: barra de envio gratis + confeti al desbloquear --------
       El umbral se lee del data-atributo que imprime Liquid: es un ajuste del
       theme, NO un numero inventado aqui. Si no hay umbral, no se pinta nada. */
    document.querySelectorAll("[data-packs]").forEach(function (caja) {
      var umbral = parseFloat(caja.dataset.umbral || "0");
      var barra = caja.querySelector("[data-desbloqueo-relleno]");
      var texto = caja.querySelector("[data-desbloqueo-texto]");
      var sonado = false;
      if (!umbral || !barra || !texto) return;

      function pinta() {
        var sel = caja.querySelector('input[data-precio]:checked');
        var v = sel ? parseFloat(sel.dataset.precio) : 0;
        var p = Math.min(1, v / umbral);
        barra.style.width = (p * 100).toFixed(0) + "%";
        if (p >= 1) {
          texto.innerHTML = texto.dataset.hecho || "Envio gratis desbloqueado";
          if (!sonado && !quieto) { confeti(); sonado = true; }
        } else {
          sonado = false;
          var falta = (umbral - v).toFixed(2).replace(".", ",");
          texto.innerHTML = (texto.dataset.falta || "Te faltan {x} para el envio gratis").replace("{x}", "<strong>" + falta + " &euro;</strong>");
        }
      }
      caja.addEventListener("change", pinta);
      pinta();
    });

    function confeti() {
      var c = document.createElement("div");
      c.className = "nls-confeti";
      document.body.appendChild(c);
      var colores = ["var(--acento)", "var(--primario)", "var(--tinta)", "var(--acento)"];
      for (var i = 0; i < 30; i++) {
        var d = document.createElement("i");
        d.className = "nls-conf";
        d.style.left = (20 + Math.random() * 60) + "vw";
        d.style.top = "-20px";
        d.style.background = colores[i % colores.length];
        d.style.animationDelay = (Math.random() * 0.35).toFixed(2) + "s";
        d.style.animationDuration = (1.1 + Math.random() * 0.9).toFixed(2) + "s";
        c.appendChild(d);
      }
      setTimeout(function () { c.remove(); }, 2600);
    }

    /* ---- 8 · QUIZ de recomendacion ---------------------------------------- */
    document.querySelectorAll("[data-quiz]").forEach(function (q) {
      var pasos = q.querySelectorAll("[data-paso]");
      var barra = q.querySelector("[data-quiz-barra]");
      var total = pasos.length;
      q.addEventListener("click", function (e) {
        var b = e.target.closest("[data-siguiente]");
        if (!b) return;
        var sig = b.dataset.siguiente;
        pasos.forEach(function (p) { p.hidden = (p.dataset.paso !== sig); });
        if (barra) barra.style.width = (parseInt(sig, 10) / total * 100) + "%";
        var r = q.getBoundingClientRect();
        if (r.top < 0) q.scrollIntoView({ behavior: quieto ? "auto" : "smooth", block: "center" });
      });
    });

  });
})();

/* 26-sep · la portada de carga ya no se pinta (layout/theme.liquid): fuera su código. */
